"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _status = require("@/api/iot/status");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
var _merchant = require("@/api/merchant");
var _feeDialog = _interopRequireDefault(require("./feeDialog"));
var _default = {
  components: {
    customPage: _customPage.default,
    myDatePicker: _myDatePicker.default,
    feeDialog: _feeDialog.default
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        orderNo: '',
        cert_name: '',
        moneyFlow: '',
        transType: '',
        serviceFeeType: '',
        createTime: ''
      },
      transType: [],
      serviceFeeType: [],
      serviceFeeList: [],
      tableData: [],
      total: 0,
      total_amount: 0,
      service_fee: 0,
      withdrawal: 0,
      charge: 0,
      viewItem: {},
      transTypeList: []
    };
  },
  mounted: function mounted() {
    this.getServiceFeeList();
    this.getTranTypeList();
    this.getList();
  },
  methods: {
    getTranTypeList: function () {
      var _getTranTypeList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _status.getTranTypeList)();
              case 2:
                res = _context.sent;
                if (res) {
                  this.transTypeList = res;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getTranTypeList() {
        return _getTranTypeList2.apply(this, arguments);
      }
      return getTranTypeList;
    }(),
    // 获取数据
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      (0, _merchant.reconciliationFlow)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.loading = false;
        console.log('reconciliationFlow', res);
        _this.tableData = res.data || [];
        _this.total = res.total;
        _this.total_amount = res.total_amount || 0;
      });
    },
    getServiceFeeList: function getServiceFeeList() {
      var _this2 = this;
      (0, _merchant.getServiceFeeList)().then(function (res) {
        // console.log('res', res)
        _this2.serviceFeeList = res;
      }).catch(function (error) {});
    },
    openFeeDialog: function openFeeDialog(item) {
      if (item.service_fee > 0) {
        this.viewItem = item;
        this.$refs.feeDialog.dialogVisible = true;
      }
    },
    goToOrder: function goToOrder(orderId) {
      if (orderId) {
        this.$router.push({
          name: 'orderList',
          params: {
            orderId: orderId
          }
        });
      }
    },
    // 查询
    search: function search() {
      var pickerVal = this.$refs.myDatePicker.getVal();
      if (pickerVal !== 'error') {
        this.searchForm.createTime = pickerVal;
        this.$refs.customPage.page = 1;
        this.getList();
      }
    },
    // 重置
    reset: function reset() {
      if (this.$refs.myDatePicker) {
        this.$refs.myDatePicker.reset();
      }
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    },
    transTypeChangeString: function transTypeChangeString(val) {
      this.searchForm.trans_type = val.join(',');
    },
    serviceFeeTypeChangeString: function serviceFeeTypeChangeString(val) {
      this.searchForm.serviceFeeType = val.join(',');
    },
    // 导出
    exportFile: function exportFile() {
      var pickerVal = this.$refs.myDatePicker.getVal();
      if (pickerVal !== 'error') {
        this.searchForm.createTime = pickerVal;
        (0, _merchant.reconciliationExport)(this.searchForm);
      }
    }
  }
};
exports.default = _default;